import axios from 'axios';
import { FishGroupSnapshot } from 'views/planning-prognosis/features/view-fish-group/types/fish-group-snapshot.type';

// GET
// /ewosapi/v1/planandprognosis/fishgroup/{fishGroupId}/snapshot
export const getFishGroupSnapshots = async (fishGroupId: string): Promise<FishGroupSnapshot[]> => {
  const res = await axios.get<FishGroupSnapshot[]>(`/ewosapi/v1/planandprognosis/fishgroup/${fishGroupId}/snapshot `);
  return res.data;
};
